module.exports = __webpack_public_path__ + "static/media/logo.2e5a7a23.png";